export default __webpack_public_path__ + "static/media/normal.ef4ecbc9.jpg";